const createTypeMapping = {
    createFriday: 'SMART_NEW',
    linkFriday: 'SMART_LINK',
    createEDI: 'SMART_NEW'
};

export { createTypeMapping };
